import React, {Component} from 'react';
import Card from "react-bootstrap/Card";
import Collapse from "react-bootstrap/Collapse";
import CustomButton from "./CustomButton";

// Crea un componente gráfico de dashboard.
class DashboardGraph extends Component {
    // Constructor de la clase gráfico de dashboard.
    constructor(props) {
        super(props);
        this.triggerId = props.triggerId;
        this.collapseId = props.collapseId;
        this.chartId = props.chartId;
        this.cardTitleClass = props.cardTitleClass;
        this.cardTitle = props.cardTitle;
        this.cardShadow = (props.cardShadow ? " shadow" : "");
        this.state = {show: false};
        this.toggleBody = this.toggleBody.bind(this);
    }

    // Dibuja la gráfica.
    render() {
        return (
            <Card className={"mb-4 w-100" + this.cardShadow} onClick={this.toggleBody}>
                <Card.Header id={this.triggerId} href={'#' + this.triggerId} as="a" className="collapsed d-block py-3" data-toggle="collapse" data-target={'#' + this.collapseId} aria-expanded="false" aria-controls={this.collapseId}>
                    <h6 id={this.triggerId + "Title"} className={"m-0 font-weight-bold " + this.cardTitleClass}>{this.cardTitle}</h6>
                </Card.Header>
                <Collapse in={this.state.show}>
                    <div id={this.collapseId}>
                        <Card.Body>
                            <div className="row flex-row-reverse">
                                <CustomButton additionalClass={"btn-primary"} text={this.props.resetZoom} parentFunction={this.props.btnFunction} />
                            </div>
                            <div className="chart-area">
                                <canvas id={this.chartId}/>
                            </div>
                        </Card.Body>
                    </div>
                </Collapse>
            </Card>
        );
    }

    // Muestra u oculta el cuerpo de la gráfica.
    toggleBody(e) {
        e.preventDefault();
        const trigger = document.getElementById(this.triggerId);
        const title = document.getElementById(this.triggerId + "Title");
        if (e.target === trigger || e.target === title) {
            if (trigger.classList.contains("collapsed")) {
                trigger.classList.remove("collapsed");
            } else {
                trigger.classList.add("collapsed");
            }
            this.setState({show: !this.state.show});
        }
    }
}

export default DashboardGraph;